/**
 * Parse dates from various formats (Firestore timestamps, ISO strings, unix epochs).
 * Ported from old App.js.
 */
export function parseDate(dateValue: unknown): Date | null {
  if (!dateValue) return null;

  // Already a Date object
  if (dateValue instanceof Date && !isNaN(dateValue.getTime())) {
    return dateValue;
  }

  // Firestore timestamp with seconds property
  if (
    dateValue &&
    typeof dateValue === "object" &&
    "seconds" in (dateValue as Record<string, unknown>)
  ) {
    return new Date(
      ((dateValue as Record<string, number>).seconds) * 1000
    );
  }

  // Firestore timestamp with _seconds property
  if (
    dateValue &&
    typeof dateValue === "object" &&
    "_seconds" in (dateValue as Record<string, unknown>)
  ) {
    return new Date(
      ((dateValue as Record<string, number>)._seconds) * 1000
    );
  }

  // Firestore Timestamp with toDate()
  if (
    dateValue &&
    typeof dateValue === "object" &&
    typeof (dateValue as { toDate?: () => Date }).toDate === "function"
  ) {
    return (dateValue as { toDate: () => Date }).toDate();
  }

  // String
  if (typeof dateValue === "string") {
    const parsed = new Date(dateValue);
    if (!isNaN(parsed.getTime())) return parsed;
  }

  // Number (unix ms)
  if (typeof dateValue === "number") {
    return new Date(dateValue);
  }

  // Nested value/timestamp
  if (dateValue && typeof dateValue === "object") {
    const obj = dateValue as Record<string, unknown>;
    if (obj.value) return parseDate(obj.value);
    if (obj.timestamp) return parseDate(obj.timestamp);
  }

  return null;
}
